// Import model
import { Organization } from '../models/Organization';

// Import base class serializer
import { EntitySerializer } from './EntitySerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for Organization - handles JSON serialization and deserialization with type validation
 */
export class OrganizationSerializer {
  /**
   * Deserializes a JSON string into a Organization instance
   */
  static deserialize(json: string): Organization {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a Organization instance
   */
  static fromObject(obj: any): Organization {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to Organization');
    }


    const instance: Organization = {
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      id: obj['_id'] as string | undefined,
      t: obj['_t'] as string,
      email: obj['email'] as string | undefined,
      phone: obj['phone'] as string | undefined,
      timeZone: obj['timeZone'] as string | undefined,
      organizationId: obj['organizationId'] as string | undefined,
      organizationIdName: obj['organizationId|Name'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
      branchNumber: obj['branchNumber'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of Organization instances
   */
  static deserializeArray(json: string): Organization[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a Organization instance to a JSON string
   */
  static serialize(instance: Organization): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a Organization instance to a plain object
   */
  static toObject(instance: Organization): any {
    return {
      'name': instance.name,
      'description': instance.description,
      '_id': instance.id,
      '_t': instance.t,
      'email': instance.email,
      'phone': instance.phone,
      'timeZone': instance.timeZone,
      'organizationId': instance.organizationId,
      'organizationId|Name': instance.organizationIdName,
      'isActive': instance.isActive,
      'branchNumber': instance.branchNumber,
    };
  }

  /**
   * Serializes an array of Organization instances to a JSON string
   */
  static serializeArray(instances: Organization[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
